<!--
 * @Description: 
 * @LastEditors: jml
 * @Date: 2020-11-14 17:08:35
-->
<template>
  <div>
    <div v-if="!isDesktop" class="box">
      <h3 style="text-align:center;">输入口令验证：</h3>
      <van-field v-model="word" placeholder="请输入口令" class="word" clearable></van-field>
      <van-button type="primary" class="confirmBtn" @click="finish" :disabled="word === ''">完成验证</van-button>
      <van-button
        type="default"
        @click="onLogout"
        class="confirmBtn plain"
        style="margin-top: 0.91rem"
      >退 出</van-button>
    </div>
    <div v-if="isDesktop">
      <pcWord></pcWord>
    </div>
  </div>
</template>
<script>
import { jumpBeforeRegisterUrl } from '@/utils/storage';
import { customerUser } from '@/api/ajax';
import { mapState } from 'vuex';
import pcWord from './components/pcWord';
export default {
  components: {
    pcWord
  },
  data() {
    return {
      word: ''
    };
  },
  computed: {
    ...mapState({
      isDesktop: state => state.living.isDesktop
    })
  },
  methods: {
    finish() {
      customerUser
        .channelCommand({
          command: this.word
        })
        .then(res => {
          let jumpUrl = jumpBeforeRegisterUrl();
          if (!jumpUrl) {
            this.$router.push({
              name: 'home'
            });
          }
        });
    },
    async onLogout() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push({ name: 'register' });
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  padding: 3rem 0 0 0;
}
h3 {
  margin-bottom: 0.43rem;
}
h4 {
  margin-bottom: 1.6rem;
}
p {
  margin-bottom: 0.53rem;
}
.word {
  padding: 0;
  width: 8.51rem;
  height: 1.47rem;
  background: #f6f6f6;
  opacity: 1;
  border-radius: 1rem;
  border-radius: 0.73rem;
  margin: 0 auto;
  position: relative;
  margin-top: 1.15rem;
  /deep/input {
    text-align: center;
    height: 1.47rem;
  }
  /deep/ .van-field__clear {
    font-size: 0.8rem;
    opacity: 0.7;
    position: absolute;
    right: 0.3rem;
  }
}
.confirmBtn {
  display: block;
  width: 8.51rem;
  height: 1.47rem;
  border-radius: 1rem;
  margin: 0 auto;
  margin-top: 0.75rem;
  span {
    font-weight: normal;
  }
  &.plain {
    background: transparent;
    border: 1px solid #adadad;
    span {
      color: #2d2d2d;
    }
  }
}
</style>
